
$(document).ready(function(){

// setTimeout(function(){
//   var instaHeading = $('.instagram-section-heading').attr('value');
//   var instaSubheading = $('.instagram-section-subheading').attr('value');
//   $("#insta-feed").prepend(`<h2>${instaSubheading}</h2>`);
//   $("#insta-feed").prepend(`<p>${instaHeading}</p>`);
// },2000)

//  $(".select-options li").on("click", function() {
//   stem = $(this);
//     stem.toggleClass("selected");

//           $(".select-options li")
//       .not(stem)
//       .addClass("country-selected");
// var cityname = $('.accordion-custom-jtpl').attr('name-city');
// alert(cityname);

      
//   });





  
/*
Reference: http://jsfiddle.net/BB3JK/47/
*/
function convertToSlug(Text) {
  return Text.toLowerCase()
    .replace(/ /g, "-")
    .replace(/[^\w-]+/g, "");
}
$('#mounth').each(function(){
    var $this = $(this), numberOfOptions = $(this).children('option').length;
  
    $this.addClass('select-hidden'); 
    $this.wrap('<div class="select-new"></div>');
    $this.after('<div class="select-styled"></div>');

    var $styledSelect = $this.next('div.select-styled');
    $styledSelect.text($this.children('option').eq(0).text());
  
    var $list = $('<ul />', {
        'class': 'select-options getMyLocation'
    }).insertAfter($styledSelect);
  
    for (var i = 0; i < numberOfOptions; i++) {
        $('<li />', {
            text: $this.children('option').eq(i).text(),
            rel: $this.children('option').eq(i).val(),
            name_state:convertToSlug($this.children('option').eq(i).text())
        }).appendTo($list);
        if ($this.children('option').eq(i).is(':selected')){
          $('li[rel ="' + $this.children('option').eq(i).val() + '"]').addClass('is-selected'),
              $('li[name_state ="' + convertToSlug($this.children('option').eq(i).text()) + '"]').addClass('is-selected')
        }
    }
  
    var $listItems = $list.children('li');
  
    $styledSelect.click(function(e) {
        e.stopPropagation();
        $('div.select-styled.active').not(this).each(function(){
            $(this).removeClass('active').next('ul.select-options').hide();
        });
        $(this).toggleClass('active').next('ul.select-options').toggle();
    });
  
    $listItems.click(function(e) {
        e.stopPropagation();
        $styledSelect.text($(this).text()).removeClass('active');
        $this.val($(this).attr('rel'));
      $list.find('li.is-selected').removeClass('is-selected');
      $list.find('li[rel="' + $(this).attr('rel') + '"]').addClass('is-selected');
   //   $list.find('li[name_state="' + $(this).attr('name_state') + '"]').addClass('is-selected');
        $list.hide();
        //console.log($this.val());

      var getCurrentVal = $(this).attr('name_state');
      var getCity = $('.accordion-custom-jtpl[name-city="'+getCurrentVal+'"]').length;
      if(getCity > 0){
        $('.accordion-custom-jtpl').hide();
        $('.accordion-custom-jtpl[name-city="'+getCurrentVal+'"]').show();
      } else{
        $('.accordion-custom-jtpl').show();
      }
      
    });
  
    $(document).click(function() {
        $styledSelect.removeClass('active');
        $list.hide();
    });
$('.select-options').wrapAll('<div class="ul_parent_jtpl"></div>');
});















  
// $(document).on('load resize scroll', function(){

//    if($(window).width() > 769)
//     {
//        var imgHeight = $('.faq-with-image-jtpl .image_right_side img').height(); 
// var ttlHeight = imgHeight - 100;
// $('.faq__content').css('height', ttlHeight);

//     }   
// });
    // $('.testimonial-slider').slick({
    //     autoplay: true,
    //     autoplaySpeed: 2000,
    //     speed: 600,
    //     draggable: true,
    //     infinite: true,
    //     slidesToShow: 3,
    //     slidesToScroll: 1,
    //     arrows: false,
    //     dots: false,
    //     responsive: [
    //         {
    //           breakpoint: 991,
    //           settings: {
    //             slidesToShow: 2,
    //             slidesToScroll: 1,
    //           }
    //         },
    //         {
    //             breakpoint: 575,
    //             settings: {
    //               slidesToShow: 1,
    //               slidesToScroll: 1,
    //             }
    //         }
    //     ]
    // });


$('.image-text-slide-inner').slick({
     slidesToShow:4,
        slidesToScroll:2,
        arrows: false,
        dots: false,
        speed: 500,
        infinite: true,
        autoplaySpeed: 2000,
        autoplay: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
	
// $('.testimonial-slider').slick({
//      slidesToShow:3,
//         slidesToScroll: 2,
//         arrows: false,
//         dots: false,
//         speed: 500,
//         infinite: true,
//         autoplaySpeed: 2000,
//         autoplay: true,
//   responsive: [
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 2,
//         infinite: true,
//         dots: true
//       }
//     },
//     {
//       breakpoint: 600,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     }
//     // You can unslick at a given breakpoint now by adding:
//     // settings: "unslick"
//     // instead of a settings object
//   ]
// });
	


  
$('.image_slide').slick({
  // dots: true,
  // infinite: false,
  // slidesToShow: 2,
  // slidesToScroll:2,
  // arrows: false,
  // speed: 300,
  // infinite: true,
  // autoplaySpeed: 4000,
  // autoplay: true,
  //  centerMode: true,
  // centerPadding: '20px',
  // variableWidth: true,
         slidesToShow:5,
        slidesToScroll: 3,
        centerMode: true,
        arrows: true,
        dots: false,
        speed: 300,
        centerPadding: '20px',
        infinite: true,
        autoplaySpeed: 5000,
        variableWidth: true,
        autoplay: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});


  
  $('.slide-text').slick({
  dots: true,
  infinite: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: false,
  speed: 300,
  infinite: true,
  autoplaySpeed: 4000,
  autoplay: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll:1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});


mobileOnlySlider(".logo-list", true, false, 999);

function mobileOnlySlider($slidername, $dots, $arrows, $breakpoint) {
	var slider = $($slidername);
	var settings = {
		mobileFirst: true,
		dots: $dots,
		arrows: $arrows,
		responsive: [
			{
				breakpoint: $breakpoint,
				settings: "unslick"
			}
		]
	};

	slider.slick(settings);

	$(window).on("resize", function () {
		if ($(window).width() > $breakpoint) {
			return;
		}
		if (!slider.hasClass("slick-initialized")) {
			return slider.slick(settings);
		}
	});
} // Mobile Only Slider

  
});


$(document).ready(function(){
  setTimeout(function(){
    $(".getMyLocation li:nth-child(8)").addClass('okk');
    $(".getMyLocation li:nth-child(8)").trigger('click');
  }, 100);

  $('.image-with-text-block .button-group a[href="#applyapplication"]').click(function() {
    $('html, body').animate({
        scrollTop: $("#applyapplication").offset().top-100
    }, 1500);
  });
  
});
